<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-alert outlined class="my-0" color="deep-purple lighten-1" dense :style="estiloTimerActivo()">
                        <v-row dense>
                            <v-col>
                                <div class="d-flex flex-no-wrap justify-space-between">
                                    <v-card-title class="headline vcard_timer">
                                        {{timer.grupo.nombre}}
                                    </v-card-title>
                                    <v-card-title class="headline vcard_timer">
                                        <v-btn icon>
                                            <v-icon @click="dialogEliminar=true, pausarTimer(), setTabConTimerActivo('parado')">mdi-delete</v-icon>
                                        </v-btn>
                                    </v-card-title>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col class="text-center" cols="12" md="3">
                                <v-card-subtitle class="text-h5 vcard_timer">
                                    {{ (10 > timer.hora) ? '0' + timer.hora : timer.hora }} : 
                                    {{ (10 > timer.minuto) ?  '0' + timer.minuto : timer.minuto }} : 
                                    {{ (10 > Math.trunc(timer.segundo)) ? '0' + Math.trunc(timer.segundo) : Math.trunc(timer.segundo) }}
                                </v-card-subtitle>
                                <v-list-item-icon class="mx-3">
                                    <v-btn icon>
                                        <v-icon @click="dialogReiniciar = true">mdi-reload</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                                <v-list-item-icon class="mx-3">
                                    <v-btn icon>
                                        <v-icon v-if="!running" @click="iniciarTimer">mdi-play</v-icon>
                                        <v-icon v-else @click="pausarTimer(), setTabConTimerActivo('parado')">mdi-pause</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                                <v-list-item-icon class="mx-3">
                                    <v-btn icon>
                                        <v-icon @click="inicializarDatosImputar()">mdi-calendar-check</v-icon>
                                    </v-btn>
                                </v-list-item-icon>
                            </v-col>
                            <v-col cols="12" md="9">
                                <v-combobox 
                                    v-model="timer.comentarios" 
                                    :items="comentarios"
                                    item-text="texto"
                                    class="mx-2" label="Comentarios" rows="3"
                                    color="deep-purple lighten-1"
                                    item-value="text"
                                    :return-object="false"
                                ></v-combobox>
                            </v-col>
                        </v-row>
                    </v-alert > 
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
        <v-dialog v-model="dialogEliminar" persistent max-width="380">
            <v-card>
                <v-card-title class="headline">¡Atención!</v-card-title>
                <v-card-text>¿Estás seguro de que quieres eliminar el timer?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogEliminar = false">Cancelar</v-btn>
                    <v-btn color="error" text @click="eliminarTimer()">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="dialogReiniciar" persistent max-width="380">
            <v-card>
                <v-card-title class="headline">¡Atención!</v-card-title>
                <v-card-text>¿Estás seguro de que quieres reiniciar el timer?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogReiniciar = false">Cancelar</v-btn>
                    <v-btn color="error" text @click="reiniciarTimer">Reiniciar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="dialogConfirmacionDatos" persistent max-width="750">
            <v-card>
                <v-card-title class="headline"><p>Datos a imputar:</p> <p class="text-uppercase ml-3">{{timer.grupo.nombre}}</p></v-card-title>
                <v-card-text>
                    <v-row>
                    <v-col cols="12" sm="6" class="pt-0">
                        <v-dialog ref="dialogFecha" v-model="modalFecha" :return-value.sync="fecha" persistent width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field 
                            v-model="fechaFormateada" 
                            prepend-icon="mdi-calendar" 
                            label="Fecha" v-bind="attrs" 
                            v-on="on" 
                            @blur="fecha = parseDate(fechaFormateada)" 
                            readonly
                            ></v-text-field>
                        </template>
                        <v-date-picker v-model="fecha" scrollable :first-day-of-week="1">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modalFecha = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="$refs.dialogFecha.save(fecha)">Aceptar</v-btn>
                        </v-date-picker>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" sm="6" class="pt-0">
                        <v-dialog ref="dialogHora" v-model="modalHora" :return-value.sync="hora" persistent width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="hora" label="Hora" prepend-icon="mdi-clock-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-time-picker v-if="modalHora" v-model="hora" format="24hr" full-width>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modalHora = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="$refs.dialogHora.save(hora)">Aceptar</v-btn>
                        </v-time-picker>
                        </v-dialog>
                    </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" class="pt-0">
                            <v-select :items="ambitos" item-text="ambito" label="Ámbito" v-model="ambito"  prepend-icon="mdi-clipboard-text-outline" return-object></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" class="pt-0">
                            <v-select :items="gradosurgencia" item-text="urgencia" label="Urgencia" v-model="gradourgencia" return-object prepend-icon="mdi-alert-octagon-outline"></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" class="pt-0">
                            <v-select :items="tiempoAccion" label="Tiempo por acción" v-model="tiempo" prepend-icon="mdi-timer-outline"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" class="pt-0">
                            <v-dialog ref="dialogTiempoTotal" v-model="modalTiempoTotal" :return-value.sync="tiempoTotal" persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="tiempoTotal" label="Tiempo total" prepend-icon="mdi-clock-outline" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-time-picker v-if="modalTiempoTotal" v-model="tiempoTotal" format="24hr" full-width>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="modalTiempoTotal = false">Cancelar</v-btn>
                                    <v-btn text color="primary" @click="$refs.dialogTiempoTotal.save(tiempoTotal)">Aceptar</v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pt-0">
                            <v-combobox 
                                v-model="descripcion" 
                                :items="comentarios"
                                item-text="texto"
                                class="mx-2" label="Comentarios" rows="3"
                                color="deep-purple lighten-1"
                                item-value="text"
                                :return-object="false"
                            ></v-combobox>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogConfirmacionDatos = false">Cancelar</v-btn>
                    <v-btn color="primary" text @click="mostrarDialog()" :disabled="comprobarTiempoTotal() || this.$v.descripcion.$invalid">Ir a imputar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      </v-row>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import axios from 'axios';
import { required } from 'vuelidate/lib/validators';
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default {
    name: 'TimerGrupo',
    data: () => ({
        interval: null,
        running: false,
        loading: false,
        search: '',
        timer: {},
        dialogEliminar: false,
        dialogReiniciar: false,
        dialogConfirmacionDatos: false,
        headersEditar: [
            {
                text: '',
                filterable: false,
                sortable: false,
                value: 'seleccion'
            },
            {
                text: 'Cliente',
                filterable: true,
                value: 'nombre',
            },
            {
                text: 'Tiempo',
                filterable: true,
                value: 'tiempo',
            },
        ],
        comentarios: [],

        dialogFecha: false,
        modalFecha: false,
        fechaFormateada: null,
        fecha: '',
        dialogHora: false,
        modalHora: false,
        hora: '',
        dialogTiempoTotal: false,
        modalTiempoTotal: false,

        contratos: [],
        contrato:{},
        ordenContratos: null,
        ambitos: [],
        ambito: {},
        gradosurgencia: [],
        gradourgencia: {},
        tiempoAccion: ['15 minutos', '30 minutos', '45 minutos', '60 minutos'],
        tiempo: '',
        tiempoTotal: '',
        descripcion: '',
        clientes: [],
        timerEliminado: false,
        desmontandoComponente: false
    }),
    async created() {
        this.timer = this.timersGrupos.filter(timer => {
            return timer.id === this.$vnode.key; 
            
        })[0];

        if (this.idTimerActivo === this.timer.grupo.id){
            this.iniciarTimer();
        }  

        //CARGAR COMENTARIOS BBDD
        let respuesta = await axios.get('/api/comentarios'); 
        let comentariosPublicos = respuesta.data.filter(g => g.publico == 0);
        let comentariosPribados = respuesta.data.filter(g => g.publico == 1);
        if(comentariosPublicos.length != 0){
          this.comentarios.push({ header: 'Comentarios privados'});
          comentariosPublicos.forEach(comentario => {
            this.comentarios.push(comentario);
          });
        }
        if(comentariosPribados.length != 0){
          if(comentariosPublicos.length != 0){ this.comentarios.push({ divider: true });}
          this.comentarios.push({ header: 'Comentarios públicos' });
          comentariosPribados.forEach(comentario => {
            this.comentarios.push(comentario);
          });
        } 
        
        this.setSumarCantidadTimersTotal();
    },
    methods: {       
        ...mapActions(['setLoading', 'setSnackbar']),
        ...mapActions('arditimer', ['setDialogG', 'setIdTimerActivo', 'setEliminarTimer', 'setTimer','setAutoGuardado', 'setTabConTimerActivo', 'setEliminarTimerGrupo', 'setSumarCantidadTimersTotal', 'setRestarCantidadTimersTotal', 'setCerrarSesion', 'setTimersGrupo', 'setTimers', 'setErrorGuardado', 'setCopiaCantidadTimersTotal', 'setGuardando']),       
        ...mapActions('accionesMasivas', ['setDatosAccion']),    
        ...mapActions('login', ['setForzadoCerrarSesion']),    
        iniciarTimer(){
            this.setTabConTimerActivo('');
            this.setIdTimerActivo(this.$vnode.key);
            this.running = true;
            // Obtengo el tiempo al iniciar el timer
            let tiempoInicio = Date.now();
            this.interval = setInterval(() => {
                // Obtengo el tiempo actual
                let tiempoActual = Date.now();
                // Comparando el tiempo actual con el tiempo del inicio, podemos saber cuantos segundos han pasado
                let tiempoTranscurrido = ((tiempoActual-tiempoInicio)/1000);
                this.timer.segundo = this.timer.segundo + tiempoTranscurrido;
                if (this.timer.segundo >= 60){
                    this.timer.minuto++;
                    this.timer.segundo = this.timer.segundo - 60;
                }
                if (this.timer.minuto >= 60){
                    this.timer.hora++;
                    this.timer.minuto = this.timer.minuto - 60;
                }
                // Igualo el tiempo actual al inicial para que la próxima iteración cuente los segundos que han pasado desde la última iteración
                tiempoInicio = tiempoActual;
            },100);
        },
        reiniciarTimer(){
            if(this.idTimerActivo == this.$vnode.key){
                this.setTabConTimerActivo('parado');
            }
            this.dialogReiniciar = false
            this.pausarTimer();
            this.timer.hora = 0;
            this.timer.segundo = 0;
            this.timer.minuto = 0;
            let date = new Date;
            this.timer.horaInicio = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()); //restablecemos hora inicio a la actual
        },
        pausarTimer(){
            this.running = false;
            clearInterval(this.interval);
            this.interval = null;
        },
        async eliminarTimer(){ 
            this.setLoading(true);
            try{
                this.timer.id = this.timer.id.replace(/g/g, ''); 
                await axios.delete(`/api/arditimersGrupos/${this.timer.id}`);
                this.setEliminarTimerGrupo(this.timer);
                this.dialogEliminar = false;
                this.interval = null;
                this.timerEliminado = true;
                this.setRestarCantidadTimersTotal();
                this.setLoading(false);
            } catch (error) {
                this.setLoading(false);
                this.dialogEliminar = false;
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se ha podido eliminar el timer'
                });
            }
        },
        mostrarDialog(){
            this.setLoading(true);
            /** solucion temporal: la unica que funciona :) */
            setTimeout( () => {
                this.dialogConfirmacionDatos = false;
                let datos = {
                    timer: this.timer,
                    grupo: this.timer.grupo,
                    fecha: this.fechaFormateada,
                    hora: this.hora,
                    ambitos: this.ambitos,
                    ambito: this.ambito,
                    gradosurgencia: this.gradosurgencia,
                    gradourgencia: this.gradourgencia,
                    tiempoAccion: this.tiempo,
                    descripcion: this.descripcion,
                    ordenContratos: this.ordenContratos,
                    contrato: this.contrato,
                    tiempoTotal: this.tiempoTotal,
                    clientes: this.clientes
                }
                this.setDatosAccion(datos);
                this.setDialogG(true);
            },250) 

        },
        async autoGuardadoBDD(){
             try{
                await axios.patch('/api/arditimersGrupos', this.timer);
            } catch (error) {
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido autoguardar los timers'
                });
            }
            // if(this.desmontandoComponente == false){
            //     this.setLoading(true);
            // }

            // try{
            //     await axios.patch('/api/arditimersGrupos', this.timer);
            // } catch (error) {
            //     this.setErrorGuardado(true);
            // }

            // if(this.cerrarSesion === false){
            //     this.setCopiaCantidadTimersTotal(this.cantidadTimersTotalCopia - 1);
            //     if(this.cantidadTimersTotalCopia == 0 || this.cantidadTimersTotalCopia == 1){
            //         // if(this.desmontandoComponente == true || (this.cantidadTimersTotalCopia == 0 && this.desmontandoComponente == false)){
            //             this.avisoGuardado();
            //             if(this.desmontandoComponente == false){
            //                 this.setLoading(false);
            //             }else{
            //                 this.setRestarCantidadTimersTotal();

            //             }
            //             if(this.errorGuardado == false){
            //                 this.setAutoGuardado(this.autoGuardado);   
            //             }
            //         // }
            //     }
            // }

            if(this.cerrarSesion === true){
                this.setRestarCantidadTimersTotal();
                if(this.cantidadTimersTotal == 1){
                    this.setCerrarSesion(null);
                    this.setSnackbar({
                        tipo: 'green',
                        mensaje: 'Los timers se han guardados correctamente.'
                    });
                    this.setForzadoCerrarSesion(true);
                }
            }
        },
        // avisoGuardado(){
        //     if(this.errorGuardado == false){
        //         this.setSnackbar({
        //             tipo: 'green',
        //             mensaje: 'Los timers se han guardados correctamente.'
        //         });
        //     }else{
        //         this.setErrorGuardado(false);
        //         this.setSnackbar({
        //             tipo: 'error',
        //             mensaje: 'Error. No se han podido guardar los timers.'
        //         });
        //     }
        //     this.setGuardando(false);
        // },
        avisoTimerPausado(){
            this.pausarTimer();
            this.setSnackbar({
                tipo: 'info',
                mensaje: 'El timer de ' + this.timer.grupo.nombre + ' estaba activo y ha sido pausado!'
            });
        },
        formatDate (fecha) { //cambiamos el formato de la fecha de YYYY-MM-DD a DD/MM/YYYY
            const [year, month, day] = fecha.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (fecha) { //cambiamos el formato de la fecha de DD/MM/YYYY a YYYY-MM-DD
            const [day, month, year] = fecha.split('/')
            return `${year}-${month}-${day}`
        },
        calcularHora() {
            let hoy = new Date()
            let horas = hoy.getHours() < 10 ? '0' + hoy.getHours() : hoy.getHours()            
            let minutos = ((Math.ceil((hoy.getMinutes() < 10 ? '0'+hoy.getMinutes() : hoy.getMinutes())/5)))*5; //obligo a los minutos a ser multiple de 5
            if(minutos === 60){ //monto la hora en formato hh:mm
                return Number(horas)+1 + ":00"; 
            }else{
                return horas + ":" + (minutos < 10 ? '0' + minutos : minutos);
            }
        },
        async inicializarDatosImputar(){
            this.setLoading(true);
            try {
                this.pausarTimer();
                this.setTabConTimerActivo('parado'); 
                
                let respuesta = await axios.get("/api/contratos");//LISTAR CONTRATOS BDD
                this.contratos = respuesta.data;
                
                respuesta = await axios.get("/api/ambitos");//LISTAR AMBITOS BDD
                this.ambitos = respuesta.data;
                this.ambito = this.ambitos.filter(a => a.id == 5)[0];

                respuesta = await axios.get("/api/gradosurgencia");//LISTARA GRADO DE URGENCIA BDD
                this.gradosurgencia = respuesta.data;
                this.gradourgencia = this.gradosurgencia.filter(g => g.id == 4)[0];

                respuesta = await axios.get('/api/clientes'); //LISTAR TODOS LOS CLIENTES BBDD
                let clientesTodos = respuesta.data;

                respuesta = await axios.get(`/api/gruposaccionesmasivas/${this.timer.grupo.id}`);//CARGAR CLIENTES CORRESPONDIENTES AL GRUPO CON CONTRATOS Y DELEGACIÓN  
                this.clientes = respuesta.data;
                
                if(this.clientes.length == 0){
                    this.setLoading(false);
                    this.setSnackbar({
                        tipo: "warning",
                        mensaje: "El grupo elegido no consta de clientes",
                    });
                }else{
                    respuesta = await axios.get("/api/usuarios?grupo=3"); //LISTAR COMERCIALES BBDD
                    let comerciales = respuesta.data;

                    this.clientes.forEach(cliente => { //Añado al cliente su nombre y su comercial
                        let datos =  clientesTodos.filter(c => c.code === cliente.cliente_id);
                        if(datos.length > 0){
                            console.log("************")
                            console.log(datos)
                            console.log(comerciales.filter(item => item.email === datos[0].comercialEmail))
                            console.log("************")
                            cliente.name = datos[0].name;
                            cliente.comercial_id = comerciales.filter(item => item.email === datos[0].comercialEmail)[0].id;
                            cliente.delegacion_id = cliente.delegaciones.delegacionId;
                        }
                        // this.ordenContratos(cliente);
                    });
       
                    this.fechaFormateada = this.formatDate(new Date().toISOString().substr(0, 10));
                    this.fecha = this.parseDate(this.fechaFormateada);
                    this.hora = this.calcularHora();
                    this.tiempo = '15 minutos';
                    this.tiempoTotal = this.calculoTiempoTotal();
                    this.descripcion = this.timer.comentarios;
                    if(this.timer.grupo.orden_contratos){
                        this.ordenContratos = this.timer.grupo.orden_contratos;
                    }
                }
                this.dialogConfirmacionDatos = true;
                this.setLoading(false);
            } catch (error) {
                console.log(error)
                this.setLoading(false);
                this.setSnackbar({
                    tipo: 'error',
                    mensaje: 'Error. No se han podido recuperar los datos del timer'
                });
            }
        },
        calculoTiempoTotal(){
            let horas = this.timer.hora
            let minutos = (this.timer.minuto/5)*5; //obligo a los minutos a ser multiple de 5
            if(minutos === 60){
                return (horas < 9 ? '0' + Number(horas+1) : Number(horas+1)) + ":00"; 
            }else{
                return (horas < 10 ? '0' + horas : horas) + ":" + (minutos < 10 ? '0' + minutos : minutos); //monto el array con el  formato hh:mm 
            }
        },
        // ordenContratos(cliente){
        //     if(this.timer.grupo.orden_contratos){              
        //         cliente.contratos_ordenados = [];
        //         let arrayOrdenContratos = this.timer.grupo.orden_contratos.split(',').map(Number);
        //         arrayOrdenContratos.forEach(cOrden => {
        //             this.contratos.forEach(contrato => {
        //                 if(cOrden == contrato.id){
        //                     cliente.contratos_ordenados.push(contrato);
        //                 }
        //             });
        //         });
        //     }else{
        //         cliente.contratos.forEach(contrato => {
        //             contrato.contrato = contrato.tipoContrato
        //         });
        //         cliente.contratos_ordenados = cliente.contratos;
        //         let ptoCerrado = cliente.contratos.find(c => c.id === 7);
        //         if(ptoCerrado) cliente.contratos_ordenados.push(cliente.contratos.splice(cliente.contratos.indexOf(ptoCerrado), 1)[0]);
        //     }
        // },
        comprobarTiempoTotal(){
            if((Number(this.tiempo.toString().substr(0,2)) <= this.tiempoTotal.substr(3,2)) || this.tiempoTotal.substr(0,2) >= 1){
                return false;
            }else{
                return true;
            }
        },
        estiloTimerActivo(){
            if(this.idTimerActivo == this.timer.id && this.contieneTimerActivo != 'parado'){
                if(this.$vuetify.theme.dark){
                    return 'border: 2px solid !important; background-color: #2a2540 !important;'
                }
                return 'border: 2px solid !important; background-color: #eaf0ff !important;'
            }
        }
    },
    computed: {
        ...mapState('arditimer', ['idTimerActivo', 'timersGrupos', 'autoGuardado', 'cantidadTimersTotal', 'cantidadTimersTotalCopia', 'cerrarSesion', 'contieneTimerActivo', 'errorGuardado', 'ultimoTimer', 'timers']),
        ...mapState('login', ['forzadoCerrarSesion'])
    },
    validations: {
      descripcion: { required }
    },
    watch: {
        idTimerActivo(){
            // Cuando el id del timer activo cambia (se ha iniciado otro timer, se está imputando otro timer) detiene todos los timers que no tienen ese id (no es el timer activo)
            if(this.idTimerActivo !== this.$vnode.key && this.interval !== null){
                this.avisoTimerPausado();
            }
        },
        autoGuardado(){
            this.autoGuardadoBDD();
        },
        fecha (val) {
            this.fechaFormateada = this.formatDate(this.fecha)
        },
    },
    beforeDestroy(){
        // this.desmontandoComponente = true;
        if(this.timerEliminado){
            this.timerEliminado = false;
        }else if(this.cerrarSesion === false){
            this.autoGuardadoBDD();
            this.setRestarCantidadTimersTotal();
        }

        if(this.interval !== null){
            this.avisoTimerPausado();
        }
        this.setIdTimerActivo('');
    }
}
</script>

<style>
    .vcard_timer{
        word-break: break-word !important;
        padding: 0px 14px !important;
    }
</style>